import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useLocale } from '@merchant-portal/merchant-portal-base'
import {
  batchImportUsers,
  clearPreviousImport,
} from '../../../store/actions/batch-import-actions'
import BatchImportUsersUI from './UI'
import { getText } from '../../../internal/TextLabels'
import { sendAddMultipleUsersEvent } from '../../../util/ga-helpers'

const toolbarItems = {
  leftItems: [
    {
      type: 'title',
      text: getText('user.import.title'),
    },
  ],
  rightItems: [
    {
      text: getText('user.import.toolbar.showUsers'),
      type: 'link',
      href: '/users',
    },
  ],
}

const BatchImportUsers = props => {
  const [locale] = useLocale()
  const [files, setFiles] = useState([])
  const [icon, setIcon] = useState('midasFileUpload')
  const [wrongFileFormat, setWrongFileFormat] = useState(false)
  const [uploadFailed, setUploadFailed] = useState(
    props.fileUploadFailed || false,
  )

  useEffect(() => {
    props.clearPreviousImport()
    sendAddMultipleUsersEvent('Start')
  }, [])

  const [batchTemplateUrl, setBatchTemplateUrl] = useState(null)
  useEffect(() => {
    const { language } = locale
    setBatchTemplateUrl(
      `/static/content/userBatchTemplate/user_batch_template_${language.toLowerCase()}.xlsx`,
    )
  }, [locale])

  const ref = useRef()
  ref.current = props.fileUploadFailed
  useEffect(() => {
    if (!ref) {
      setFiles([])
      setIcon('midasFileUpload')
      setUploadFailed(true)
      sendAddMultipleUsersEvent('File upload Failed')
    }
  }, [props.fileUploadFailed])

  const onDrop = _files => {
    if (_files.length > 0) {
      setFiles(_files)
      setIcon('midasCheck3')
      setWrongFileFormat(false)
      setUploadFailed(false)
    } else {
      setFiles([])
      setIcon('midasFileUpload')
      setWrongFileFormat(true)
      setUploadFailed(false)
    }
  }

  return (
    <BatchImportUsersUI
      toolbarItems={toolbarItems}
      files={files}
      icon={icon}
      onDrop={_files => onDrop(_files)}
      batchImport={props.batchImport}
      fileIsLoading={props.fileIsLoading}
      batchTemplateUrl={batchTemplateUrl}
      uploadFailed={uploadFailed}
      wrongFileFormat={wrongFileFormat}
    />
  )
}

BatchImportUsers.propTypes = {
  batchImport: PropTypes.func.isRequired,
  fileIsLoading: PropTypes.bool.isRequired,
  clearPreviousImport: PropTypes.func.isRequired,
  fileUploadFailed: PropTypes.bool.isRequired,
}

const mapStateToProps = state => ({
  fileIsLoading: state.batchImport.fileUploading,
  fileUploadFailed: state.batchImport.fileUploadFailed,
})

const mapDispatchToProps = dispatch => ({
  batchImport: files => dispatch(batchImportUsers(files)),
  clearPreviousImport: () => {
    dispatch(clearPreviousImport())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(BatchImportUsers)
